<script>
export default {
  name: 'kullanicilarList',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    deleteRecord(id) {
      this.$emit('deleteRecord', id);
    },
    resetRecord(id) {
      const confirmation = confirm("Emin misiniz? Şifreyi sıfırlamak istiyor musunuz?");
      if (confirmation) {
        this.$emit('resetRecord', id);
      }
    }
  },
};
</script>

<template>
  <tr>
    <td>{{ item.id }} </td>
    <td> {{ item.name }} </td>
    <td> {{ item.surname }}</td>
    <td> {{ item.email }}</td>
    <td>
      <v-btn @click="deleteRecord(item.email)" color="darken-3" small icon fat text>
        <v-icon color="red">
          mdi-close
        </v-icon>
      </v-btn>
    </td>
    <td>
      <v-btn @click="resetRecord(item.email)" color="darken-3" small icon fat text>
        <v-icon color="circle">
        mdi-check
      </v-icon>
      </v-btn>
    </td>
  </tr>
</template>
